import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { applyMustacheTemplate } from '@act/shared/utilities';
import { CollapsibleCard } from '../../../../containers/Cards/Collapsible/CollapsibleCard';
import { IconAvatar } from '../../../../display/IconAvatar/IconAvatar';
import { GoalCardActionItems } from '../../goalCardShared.types';
import { AssignedSurveyDateLine } from '../dateLines';
import { AssignedSurveyGoalSummary } from '../summaries/AssignedSurveyGoalSummary';

interface AssignedSurveyGoalCardProps {
  assignedSurvey: SurveyV2.AssignedSurveyDto;
  member: UserDto;
  actions?: GoalCardActionItems[];
  defaultClosed?: boolean;
  onToggleOpen?: () => void;
  summary?: JSX.Element;
}

export const AssignedSurveyGoalCard = ({
  assignedSurvey,
  member,
  actions,
  defaultClosed,
  onToggleOpen,
  summary,
}: AssignedSurveyGoalCardProps) => {
  const surveyMonth =
    assignedSurvey.createdAt != null
      ? new Date(assignedSurvey.createdAt).toLocaleString('default', {
          month: 'long',
          timeZone: 'UTC',
        })
      : new Date().toLocaleString('default', { month: 'long' });
  const templateVariables = {
    memberName: `${member?.firstName || 'Unknown'}`,
    month: surveyMonth,
  };
  const surveyTitle = `${applyMustacheTemplate(assignedSurvey.survey.displayName, templateVariables)} survey`;

  return (
    <CollapsibleCard
      avatar={<IconAvatar avatarType="survey" />}
      title={surveyTitle}
      titleTypographyVariant="titleMedium"
      endContent={
        <AssignedSurveyDateLine
          assignedSurvey={assignedSurvey}
          member={member}
        />
      }
      defaultClosed={defaultClosed}
      isCompact
      hideExpander
      shouldShowPointer
      onToggleOpen={onToggleOpen}
    >
      <AssignedSurveyGoalSummary
        assignedSurvey={assignedSurvey}
        member={member}
        summary={summary}
        actions={actions}
      />
    </CollapsibleCard>
  );
};
